export default "__VITE_ASSET__CkSB8ikV__"